import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
// hooks
import { AuthRouteContext } from "src/hooks/useAuth";

type RouterContext = {
	authentication: AuthRouteContext;
};

export const Route = createRootRouteWithContext<RouterContext>()({
	component: () => <Outlet />
});
